<template>
  <div class="basic-info">
    <div class="basic-info-container">
      <el-form :model="form" ref="form" label-width="auto" size="mini" :rules="addRules"
        :disabled="formDisabled || mode === 'view'">
        
        <div class="form-scroll-container">
          
          <!-- ===== 顶部固定字段区域 ===== -->
          <el-row :gutter="8" class="required-fields-row">
            <el-col :span="6">
              <el-form-item 
                label="条形码：" 
                prop="code"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.code"
                  placeholder="请输入条形码"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="药品名称：" 
                prop="drugName"
                :rules="getFieldRequiredRules('drugName')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-input 
                  v-model="form.drugName"
                  placeholder="请输入药品名称"
                  @blur="handleFieldBlur({fieldCode: 'drugName'})"
                  @input="handleFieldInput({fieldCode: 'drugName'}, $event)"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="拼音简码：" 
                prop="pyCode"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.pyCode"
                  placeholder="请输入拼音简码"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="剂型：" 
                prop="dosageForm"
                :rules="getFieldRequiredRules('dosageForm')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-select 
                  v-model="form.dosageForm"
                  placeholder="请选择剂型"
                  filterable
                  clearable
                  class="compact-select">
                  <el-option
                    v-for="item in dosageFormOptions"
                    :key="item.id"
                    :label="item.dosageName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="8" class="required-fields-row">
            <el-col :span="6">
              <el-form-item 
                label="规格：" 
                prop="drugSpec"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.drugSpec"
                  placeholder="请输入规格"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="型号：" 
                prop="model"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.model"
                  placeholder="请输入型号"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="生产厂商：" 
                prop="manufacturer"
                :rules="getFieldRequiredRules('manufacturer')"
                class="form-item-compact form-item-adaptive required-field-item">
                <div style="display:flex;align-items:center;width:100%;">
                  <el-select 
                    v-model="form.manufacturer"
                    placeholder="请选择生产厂商"
                    filterable
                    remote
                    :remote-method="handleManufacturerSearch"
                    :loading="manufacturerLoading"
                    @focus="loadManufacturers(false)"
                    v-el-select-infinite-scroll="handleManufacturerScroll"
                    class="compact-select"
                    style="flex:1;"
                    popper-class="manufacturer-select-dropdown"
                    @change="handleManufacturerChange">
                    <template slot="header">
                      <div class="select-header">
                        <span class="header-item" style="flex:0 0 80px;">厂商编码</span>
                        <span class="header-item" style="flex:2;">名称</span>
                        <span class="header-item" style="flex:1;">产地</span>
                      </div>
                    </template>
                    <el-option
                      v-for="item in manufacturerOptions"
                      :key="item.id"
                      :label="item.manufacturerName"
                      :value="item.id">
                      <div class="option-row">
                        <span class="option-item" style="flex:0 0 80px;">{{ item.coding || '-' }}</span>
                        <el-tooltip :content="item.manufacturerName" placement="top" :disabled="item.manufacturerName.length <= 12">
                          <span class="option-item" style="flex:2;text-align:left;padding-left:6px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                            {{ item.manufacturerName }}
                          </span>
                        </el-tooltip>
                        <span class="option-item" style="flex:1;">{{ item.origin || '-' }}</span>
                      </div>
                    </el-option>
                    <div v-if="manufacturerLoading" slot="empty" class="load-more">
                      <i class="el-icon-loading"></i> 加载中...
                    </div>
                    <div v-else-if="manufacturerScrollLoading" slot="empty" class="load-more">
                      <i class="el-icon-loading"></i> 加载更多...
                    </div>
                    <div v-else-if="!manufacturerHasMore && manufacturerOptions.length > 0" slot="empty" class="load-more">
                      没有更多数据了
                    </div>
                    <div v-else-if="manufacturerOptions.length === 0 && !manufacturerLoading" slot="empty" class="no-data-prompt">
                      <i class="el-icon-warning"></i>
                      <p>暂无生产厂家数据</p>
                      <el-button type="text" class="quick-add-link" @click="openAddManufacturerDialog">
                        点击添加新的厂商
                      </el-button>
                    </div>
                  </el-select>
                  <el-tooltip content="添加新的厂商" placement="top">
                    <el-button 
                      type="text" 
                      icon="el-icon-circle-plus" 
                      @click="openAddManufacturerDialog"
                      style="margin-left:4px;font-size:20px;color:#00557f;"
                    ></el-button>
                  </el-tooltip>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="批准文号：" 
                prop="manuLotnum"
                :rules="getFieldRequiredRules('manuLotnum')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-input 
                  v-model="form.manuLotnum"
                  placeholder="请输入批准文号"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="8" class="required-fields-row">
            <el-col :span="6">
              <el-form-item 
                label="剂量单位：" 
                prop="dosUnt"
                :rules="getFieldRequiredRules('dosUnt')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-select 
                  v-model="form.dosUnt"
                  placeholder="请选择剂量单位"
                  filterable
                  clearable
                  class="compact-select"
                  popper-class="custom-unit-dropdown">
                  <el-option
                    v-for="option in dosUntOptions"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id">
                    <span>{{ option.label }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="单位剂量：" 
                prop="unitDose"
                :rules="getFieldRequiredRules('unitDose')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-input 
                  v-model="form.unitDose"
                  placeholder="请输入单位剂量"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="最小剂量：" 
                prop="minDose"
                :rules="getFieldRequiredRules('minDose')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-input 
                  v-model="form.minDose"
                  placeholder="请输入最小剂量"
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="取整方式：" 
                prop="roundUnt"
                :rules="getFieldRequiredRules('roundUnt')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-select 
                  v-model="form.roundUnt"
                  placeholder="请选择取整方式"
                  filterable
                  clearable
                  class="compact-select">
                  <el-option
                    v-for="option in roundUntoptions"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="8" class="required-fields-row">
            <el-col :span="6">
              <el-form-item 
                label="效期管理：" 
                prop="periodControl"
                :rules="getFieldRequiredRules('periodControl')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-select 
                  v-model="form.periodControl"
                  placeholder="请选择效期管理"
                  clearable
                  class="compact-select"
                  @change="handlePeriodControlChange">
                  <el-option
                    v-for="item in YNoptions"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="有效期天数：" 
                prop="expyDate"
                :rules="getExpyDateRules()"
                :class="{'required-field-item': form.periodControl === 1}"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.expyDate"
                  placeholder="请输入有效期天数"
                  clearable
                  class="compact-input"
                  @input="handleInputexpyDate('expyDate', $event)">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="近期预警天数：" 
                prop="warningDays"
                :rules="getFieldRequiredRules('warningDays')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-input 
                  v-model.number="form.warningDays"
                  placeholder="请输入预警天数"
                  clearable
                  class="compact-input"
                  @input="handleNumberInput('warningDays', $event)">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="8" class="required-fields-row">
            <el-col :span="6">
              <el-form-item 
                label="有效状态：" 
                prop="state"
                :rules="getFieldRequiredRules('state')"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-select v-model="form.state" placeholder="请选择有效状态" clearable class="compact-select">
                  <el-option v-for="item in statusOptions" :key="item.id" :label="item.label" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="追溯码开关：" 
                prop="isBar"
                class="form-item-compact form-item-adaptive">
                <el-switch v-model="form.isBar" active-color="#13ce66" inactive-color="#ff4949"
                  :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="销售单位：" 
                prop="saleUnt"
                :rules="[{ required: true, message: '请选择销售单位', trigger: 'change' }]"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-select v-model="form.saleUnt" placeholder="请选择销售单位" clearable class="compact-select">
                  <el-option v-for="item in saleWaysOptions" :key="item.id" :label="item.label" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item 
                label="手工划价：" 
                prop="manualPric"
                :rules="[{ required: true, message: '请选择手工划价', trigger: 'change' }]"
                class="form-item-compact form-item-adaptive required-field-item">
                <el-select v-model="form.manualPric" placeholder="请选择手工划价" clearable class="compact-select">
                  <el-option v-for="item in manualPricOptions" :key="item.id" :label="item.label" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="8" class="required-fields-row">
            <el-col :span="6">
              <el-form-item label="医保名称：" prop="chsName" class="form-item-compact form-item-adaptive">
                <el-input v-model="form.chsName" placeholder="请输入医保名称" clearable class="compact-input" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="医保编码：" prop="chsCode" class="form-item-compact form-item-adaptive">
                <div style="display:flex;align-items:center;width:100%;">
                  <el-input v-model="form.chsCode" placeholder="请输入医保编码" clearable class="compact-input" style="flex:1;" />
                  <el-tooltip content="医保数据获取" placement="top">
                    <el-button type="text" icon="el-icon-refresh" @click="fetchMedicalInsuranceData"
                      style="margin-left:4px;font-size:18px;color:#00557f;" />
                  </el-tooltip>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6" />
            <el-col :span="6" />
          </el-row>

          <!-- ===== 非必填动态字段区域 ===== -->
          <div class="optional-fields-section" v-if="optionalFields.length > 0">
            <el-row :gutter="8" class="dynamic-fields-grid">
              <template v-for="field in optionalFields">
                <el-col 
                  :key="field.fieldCode" 
                  :span="6"
                  class="field-col">
                  <el-form-item 
                    :label="field.fieldName + '：'" 
                    :prop="field.fieldCode"
                    :rules="getFieldRules(field)" 
                    class="form-item-compact form-item-adaptive">
                    
                    <el-input 
                      v-if="field.inputBoxType === 'input'" 
                      v-model="form[field.fieldCode]"
                      :placeholder="getFieldPlaceholder(field)"
                      @blur="handleFieldBlur(field)"
                      @input="handleFieldInput(field, $event)"
                      :disabled="getFieldDisabled(field)" 
                      clearable
                      class="compact-input"
                      :class="getNumberFieldClass(field)">
                    </el-input>
                    
                    <el-select 
                      v-else-if="field.inputBoxType === 'selected'"
                      v-model="form[field.fieldCode]"
                      :placeholder="getFieldPlaceholder(field)"
                      @change="handleFieldChange(field, $event)"
                      :disabled="getFieldDisabled(field)"
                      filterable
                      clearable
                      class="compact-select">
                      <el-option
                        v-for="option in getFieldOptions(field)"
                        :key="option.id"
                        :label="option.label"
                        :value="option.id">
                      </el-option>
                    </el-select>
                    
                    <el-input
                      v-else-if="field.inputBoxType === 'inputNumber'"
                      v-model.number="form[field.fieldCode]" 
                      :placeholder="getFieldPlaceholder(field)"
                      @blur="handleFieldBlur(field)" 
                      @input="handleFieldInput(field, $event)"
                      :disabled="getFieldDisabled(field)" 
                      clearable
                      class="compact-input"
                      :class="getNumberFieldClass(field)">
                    </el-input>
                    
                    <template v-else-if="field.inputBoxType === 'checked'">
                      <el-checkbox v-for="option in getFieldOptions(field)" :key="option.value"
                        :label="option.value" v-model="form[field.fieldCode]"
                        @change="handleFieldChange(field)" class="compact-checkbox">
                        {{ option.label }}
                      </el-checkbox>
                    </template>
                    
                    <template v-else-if="field.inputBoxType === 'switch'">
                      <el-select 
                        v-model="form[field.fieldCode]"
                        :placeholder="getFieldPlaceholder(field)"
                        @change="handleFieldChange(field, $event)"
                        :disabled="getFieldDisabled(field)"
                        filterable
                        clearable
                        class="compact-select"
                        style="width:100%;">
                        <el-option
                          v-for="option in statusOptions"
                          :key="option.id"
                          :label="option.label"
                          :value="option.id">
                        </el-option>
                      </el-select>
                    </template>
                    
                    <el-cascader v-else-if="field.inputBoxType === 'cascader'" 
                      v-model="form[field.fieldCode]"
                      :options="getCascaderOptions(field)" 
                      :props="getCascaderProps(field)"
                      :placeholder="getFieldPlaceholder(field)" 
                      @change="handleFieldChange(field)" 
                      clearable
                      filterable 
                      class="compact-cascader">
                    </el-cascader>
                    
                    <el-date-picker v-else-if="field.inputBoxType === 'dateTime'"
                      v-model="form[field.fieldCode]" 
                      :type="getDatePickerType(field)"
                      :placeholder="getFieldPlaceholder(field)" 
                      @change="handleFieldChange(field)"
                      class="compact-datepicker" 
                      value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                    
                    <el-input v-else v-model="form[field.fieldCode]" 
                      :placeholder="getFieldPlaceholder(field)"
                      @blur="updateForm" 
                      @input="handleFieldInput(field, $event)" 
                      clearable
                      class="compact-input">
                    </el-input>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </div>

        </div>
      </el-form>
    </div>

    <!-- ============================================================= -->
    <!-- 快速添加生产厂商模态框 - 已改为每行4列，样式与主表单一致 -->
    <!-- ============================================================= -->
    <el-dialog 
      title="快速添加生产厂家信息" 
      :visible.sync="quickAddManufacturerDialogVisible" 
      width="90%"
      :close-on-click-modal="false" 
      append-to-body 
      class="quick-add-manufacturer-dialog">
      
      <el-form 
        :model="quickAddManufacturerForm" 
        :rules="quickAddManufacturerRules" 
        ref="quickAddManufacturerForm" 
        label-width="auto"
        size="mini"
        class="manufacturer-form">
        
        <!-- ===== 第一行：厂家名称、拼音简码、联系人、联系电话 ===== -->
        <el-row :gutter="8" class="required-fields-row">
          <el-col :span="6">
            <el-form-item 
              label="厂家名称：" 
              prop="manufacturerName"
              class="form-item-compact form-item-adaptive required-field-item">
              <el-input 
                v-model="quickAddManufacturerForm.manufacturerName" 
                placeholder="请输入生产厂家名称"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="拼音简码：" 
              prop="pinyinCode"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.pinyinCode" 
                placeholder="自动生成" 
                :disabled="true"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="联系人：" 
              prop="contacts"
              class="form-item-compact form-item-adaptive required-field-item">
              <el-input 
                v-model="quickAddManufacturerForm.contacts" 
                placeholder="请输入联系人"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="联系电话：" 
              prop="contactNumber"
              class="form-item-compact form-item-adaptive required-field-item">
              <el-input 
                v-model="quickAddManufacturerForm.contactNumber" 
                placeholder="请输入联系电话"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ===== 第二行：编码、产地、统一社会信用代码、营业执照 ===== -->
        <el-row :gutter="8" class="required-fields-row">
          <el-col :span="6">
            <el-form-item 
              label="编码：" 
              prop="coding"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.coding" 
                placeholder="请输入编码"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="产地：" 
              prop="origin"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.origin" 
                placeholder="请输入产地"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="统一社会信用代码：" 
              prop="creditCode"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.creditCode" 
                placeholder="请输入统一社会信用代码"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="营业执照：" 
              prop="businessLicense"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.businessLicense" 
                placeholder="请输入营业执照"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ===== 第三行：生产许可证、生产有效期、卫生许可证、卫生有效期 ===== -->
        <el-row :gutter="8" class="required-fields-row">
          <el-col :span="6">
            <el-form-item 
              label="生产许可证：" 
              prop="productionLicense"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.productionLicense" 
                placeholder="请输入生产许可证"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="生产有效期：" 
              prop="productionValidityPeriod"
              class="form-item-compact form-item-adaptive">
              <el-date-picker
                v-model="quickAddManufacturerForm.productionValidityPeriod"
                type="date"
                placeholder="选择生产有效期"
                value-format="yyyy-MM-dd"
                class="compact-datepicker"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="卫生许可证：" 
              prop="hygienicLicense"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.hygienicLicense" 
                placeholder="请输入卫生许可证"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="卫生有效期：" 
              prop="hygieneValidityPeriod"
              class="form-item-compact form-item-adaptive">
              <el-date-picker
                v-model="quickAddManufacturerForm.hygieneValidityPeriod"
                type="date"
                placeholder="选择卫生有效期"
                value-format="yyyy-MM-dd"
                class="compact-datepicker"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ===== 第四行：邮箱、传真、邮政编码、网址 ===== -->
        <el-row :gutter="8" class="required-fields-row">
          <el-col :span="6">
            <el-form-item 
              label="邮箱：" 
              prop="email"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.email" 
                placeholder="请输入邮箱"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="传真：" 
              prop="fax"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.fax" 
                placeholder="请输入传真"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="邮政编码：" 
              prop="postalCode"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.postalCode" 
                placeholder="请输入邮政编码"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="网址：" 
              prop="url"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.url" 
                placeholder="请输入网址"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ===== 第五行：所属地域、适用对象、有效期、可用状态 ===== -->
        <el-row :gutter="8" class="required-fields-row">
          <el-col :span="6">
            <el-form-item 
              label="所属地域：" 
              prop="region"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.region" 
                placeholder="请输入所属地域"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="适用对象：" 
              prop="applicableObject"
              class="form-item-compact form-item-adaptive">
              <el-input 
                v-model="quickAddManufacturerForm.applicableObject" 
                placeholder="请输入适用对象"
                clearable
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="有效期：" 
              prop="periodValidity"
              class="form-item-compact form-item-adaptive">
              <el-date-picker
                v-model="quickAddManufacturerForm.periodValidity"
                type="date"
                placeholder="选择有效期"
                value-format="yyyy-MM-dd"
                class="compact-datepicker"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item 
              label="可用状态：" 
              prop="status"
              class="form-item-compact form-item-adaptive required-field-item">
              <el-select 
                v-model="quickAddManufacturerForm.status" 
                placeholder="请选择状态"
                clearable
                class="compact-select"
                style="width:100%;">
                <el-option label="可用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ===== 第六行：备注（占满整行） ===== -->
        <el-row :gutter="8" class="required-fields-row">
          <el-col :span="24">
            <el-form-item 
              label="备注：" 
              prop="remake"
              class="form-item-compact form-item-adaptive">
              <el-input
                v-model="quickAddManufacturerForm.remake"
                placeholder="请输入备注"
                class="compact-input">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quickAddManufacturerDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleAddManufacturerSubmit" :loading="quickAddManufacturerLoading">确定添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pinyin } from 'pinyin-pro';
import {
  getDrugUnt,
  getDosaUnt,
  getMedicationFrequency,
  getMedicationWay,
  getMedcas,
  getDosageForm,
  getManufacturer,
  addManufacturer,
  getPariCode
} from "@/api/MedicenCata.js";

const elSelectInfiniteScroll = {
  bind(el, binding) {
    const SELECTWRAPPER_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if (SELECTWRAPPER_DOM) {
      SELECTWRAPPER_DOM.addEventListener('scroll', function() {
        const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    }
  }
};

export default {
  name: 'BasicInfo',
  directives: { 'el-select-infinite-scroll': elSelectInfiniteScroll },
  props: {
    form: { type: Object, required: true },
    formDisabled: { type: Boolean, default: false },
    mode: { type: String, default: 'add' },
    disablePackingQuantity: { type: Boolean, default: false },
    fieldConfig: { type: Array, default: () => [] }
  },
  data() {
    return {
      dynamicFields: [],
      fieldOptionsMap: new Map(),
      fieldRulesMap: new Map(),
      fieldTypeValidators: new Map(),
      specialFields: ['unitDose', 'phamType', 'dosUnt', 'pacUnt', 'minUnt'],
      fieldConfigProcessed: false,
      pendingFieldConfig: null,
      fieldRenderKey: 0,
      fieldCodeOptionsMap: new Map(),
      validateOnOpen: false,
      validationInitialized: false,
      dialogHasBeenOpened: false,
      formRules: {},
      
      antcLvOption: [
        { id: 1, label: '一级抗生素' },
        { id: 2, label: '二级抗生素' },
        { id: 3, label: '三级抗生素' }
      ],
      manualPricOptions: [
        { id: 0, label: '不允许' },
        { id: 1, label: '允许' }
      ],
      unitDoseOptions: [],
      dosUntOptions: [],
      getMinUntOptions: [],
      methodTypeOptions: [],
      unitChangeInProgress: false,
      drugCategoryOption: [],
      drugCategoryChildOption: [],
      threeLevelDrugCategoryOption: [],
      usedFrquIdOptions: [],
      expensiveTypeOptions: [
        { id: 1, label: '普价' },
        { id: 2, label: '贵重' },
        { id: 3, label: '昂贵' },
        { id: 4, label: '免费' }
      ],
      roundUntoptions: [
        { id: 1, label: '单次取整' },
        { id: 2, label: '总量取整' },
        { id: 3, label: '处方取整' }
      ],
      poisonousTypeOption: [],
      nurtureType: [
        { id: 1, label: '常规养护', value: '常规养护' },
        { id: 2, label: '重点养护', value: '重点养护' }
      ],
      lmtSpc: [
        { id: 0, label: '全院' },
        { id: 1, label: '门诊' }
      ],
      YNoptions: [
        { id: 0, label: '否', value: '否' },
        { id: 1, label: '是', value: '是' }
      ],
      statusOptions: [
        { id: 0, label: '禁用' },
        { id: 1, label: '可用' }
      ],
      saleWaysOptions: [
        { id: 1, label: '最小单位' },
        { id: 2, label: '包装单位' }
      ],
      markUpOption: [
        { id: 1, label: '比例加成' },
        { id: 2, label: '固定加成' },
        { id: 3, label: '手工比例加成' },
        { id: 4, label: '不加成' }
      ],
      medcWayIdOptions: [],
      medicalRecordFeeOption: [],
      markUpNameMap: {
        1: '比例加成',
        2: '固定加成',
        3: '手工比例加成',
        4: '不加成'
      },
      phamTypeValue: [],
      phamTypeOptions: [],
      cascaderProps: {
        value: 'id',
        label: 'label',
        children: 'children',
        lazy: true,
        lazyLoad: this.loadPhamTypeChildren,
        checkStrictly: true,
        emitPath: true
      },
      loadingPhamTypes: false,
      phamTypeCache: new Map(),
      searchText: '',
      filteredUnitOptions: [],
      dosageFormOptions: [],
      allUnitOptions: [],
      addRules: {},
      
      defaultTopFields: {
        code: '',
        model: '',
        manufacturer: '',
        manuLotnum: '',
        periodControl: 0,
        expiryMonth: null,
        expyDate: null,
        warningDays: '',
        state: 1,
        isBar: 0,
        chsName: '',
        chsCode: '',
        saleUnt: null,
        manualPric: null,
      },
      pendingPreFillData: null,
      pendingManufacturerName: '',
      manufacturerOptions: [],
      manufacturerQuery: '',
      manufacturerPageNum: 1,
      manufacturerPageSize: 100,
      manufacturerHasMore: true,
      manufacturerLoading: false,
      manufacturerScrollLoading: false,
      
      quickAddManufacturerDialogVisible: false,
      quickAddManufacturerLoading: false,
      quickAddManufacturerForm: {
        applicableObject: "",
        businessLicense: "",
        coding: "",
        contactNumber: "",
        contacts: "",
        creditCode: "",
        email: "",
        fax: "",
        hygieneValidityPeriod: "",
        hygienicLicense: "",
        id: 0,
        manufacturerName: "",
        origin: "",
        periodValidity: this.getCurrentDate(),
        pinyinCode: "",
        postalCode: "",
        productionLicense: "",
        productionValidityPeriod: this.getCurrentDate(),
        region: "",
        remake: "",
        status: 1,
        url: ""
      },
      quickAddManufacturerRules: {
        manufacturerName: [
          { required: true, message: '请输入厂家名称', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactNumber: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$|^(0\d{2,3}-?)?\d{7,8}$/, message: '请输入正确的手机号或固定电话', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    optionalFields() {
      if (!this.dynamicFields || this.dynamicFields.length === 0) return [];
      const topFieldCodes = [
        'code', 'drugName', 'pyCode', 'dosageForm',
        'drugSpec', 'model', 'manufacturer', 'manuLotnum',
        'dosUnt', 'unitDose', 'minDose', 'roundUnt',
        'periodControl', 'expiryMonth', 'expyDate', 'warningDays',
        'state', 'isBar',
        'chsName', 'chsCode', 'saleUnt', 'manualPric',
        'isBar'
      ];
      return this.dynamicFields.filter(field => {
        if (Number(field.isShow) !== 1) return false;
        if (topFieldCodes.includes(field.fieldCode)) return false;
        if (Number(field.isMustFill) === 1 || Number(field.isMustChoose) === 1) return false;
        return true;
      });
    },
  },
  watch: {
    fieldConfig: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.setFieldConfig(newVal);
        }
      }
    },
    dynamicFields: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.rebuildFieldMaps();
        });
      }
    },
    'form.kcId': {
      immediate: true,
      handler(newVal) {
        this.setPacCntDisabledState(Number(newVal));
      }
    },
    'disablePackingQuantity': {
      immediate: true,
      handler(newVal) {
        this.$forceUpdate();
      }
    },
    'form.markUpId': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$nextTick(() => {
            this.forceReRenderFields();
          });
        }
      },
      immediate: true
    },
    'form.costPric': {
      handler(newVal) {
        if (this.form.markUpId === 3 && newVal && this.form.markUpRate) {
          this.calculateSalePriceForManualMarkUp();
        } else if (this.form.markUpId === 1 && newVal) {
          // 比例加成：不做计算
        }
      }
    },
    'form.antc': {
      immediate: true,
      handler(newVal) {
        if (newVal === 1) {
          this.setMedicalRecordFeeForAntibiotic();
        }
      }
    },
    'form.state': {
      handler(newVal) {
        if (newVal !== undefined && newVal !== null && typeof newVal === 'string') {
          this.form.state = Number(newVal);
        }
      },
      immediate: true
    },
    'form': {
      deep: true,
      immediate: true,
      handler(newForm) {
        if (this.mode === 'add' && (!newForm.markUpId || newForm.markUpId === '')) {
          this.form.markUpId = 4;
          this.$nextTick(() => {
            this.handleMarkUpIdChange(4);
          });
        }
        if (this.mode === 'edit' && (newForm.phamType1 || newForm.phamType2 || newForm.phamType3)) {
          this.$nextTick(() => {
            this.initPhamTypeValue();
          });
        }
      }
    },
    'form.drugType': {
      immediate: true,
      handler(newVal) {
        if (newVal === 1) {
          this.setMedicalRecordFeeForWesternMedicine();
        }
      }
    },
    'form.pacCnt': {
      handler(newVal) {
        if (this.form.isFixPrice == 1 && this.validateOnOpen && this.$refs.form) {
          this.$nextTick(() => {
            this.$refs.form.validateField('fixPacSalePric');
          });
        }
      },
      immediate: true
    },
    'form.isFixPrice': {
      handler(newVal) {
        if (this.validateOnOpen && this.$refs.form) {
          this.$nextTick(() => {
            if (newVal == 1) {
              this.$refs.form.validateField('fixPacSalePric');
              this.$refs.form.validateField('fixMinSalePric');
            } else {
              this.$refs.form.clearValidate(['fixPacSalePric', 'fixMinSalePric']);
            }
          });
        }
      },
      immediate: true
    },
    'form.fixMinSalePric': {
      handler(newVal) {
        if (this.form.isFixPrice == 1 && this.validateOnOpen && this.$refs.form) {
          this.$nextTick(() => {
            this.$refs.form.validateField('fixPacSalePric');
          });
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.ensureTopFieldsExist();
    this.$nextTick(async () => {
      try {
        await Promise.all([
          this.pacUnt(),
          this.loadUnitOptions(),
          this.getDosaUnts(),
          this.getMedicationFrequency(),
          this.getMedicationWay(),
          this.getMedcas(),
          this.loadDosageFormOptions()
        ]);
        this.initForm();
        if (this.pendingFieldConfig) {
          this.processPendingFieldConfig();
        } else {
          this.setupDefaultFields();
        }
        if (this.form.state === undefined || this.form.state === null || this.form.state === '') {
          this.form.state = 1;
        }
        if (this.form.markUpId) {
          this.setMarkUpNameByMarkUpId(this.form.markUpId);
        }
        this.resetValidation();
        this.loadManufacturers(false);
      } catch (error) {
        this.$message.error('组件初始化失败');
      }
    });
  },
  methods: {
    applyPreFillData(data) {
      if (!data) return;
      this.pendingPreFillData = data;
      this.pendingManufacturerName = data.manufacturerName || '';
    
      if (data.drugName) this.form.drugName = data.drugName;
      if (data.drugSpec) this.form.drugSpec = data.drugSpec;
      if (data.approvalLicenceNo) {
        this.form.manuLotnum = data.approvalLicenceNo;
      } else if (data.manuLotnum) {
        this.form.manuLotnum = data.manuLotnum;
      }
    
      this.matchDosageForm(data.dosageFormName);
      this.matchManufacturer(data.manufacturerName);
    },
    
    matchDosageForm(dosageFormName) {
      if (!dosageFormName) return;
      if (this.dosageFormOptions && this.dosageFormOptions.length > 0) {
        const matched = this.dosageFormOptions.find(item => 
          item.dosageName === dosageFormName || item.label === dosageFormName
        );
        if (matched) {
          this.form.dosageForm = matched.id;
          this.form.dosForm = matched.id;
          this.form.dosformName = matched.dosageName || matched.label;
        } else {
          const tempId = Date.now();
          this.dosageFormOptions.push({
            id: tempId,
            dosageName: dosageFormName,
            label: dosageFormName
          });
          this.form.dosageForm = tempId;
          this.form.dosForm = tempId;
          this.form.dosformName = dosageFormName;
        }
      } else {
        setTimeout(() => {
          this.matchDosageForm(dosageFormName);
        }, 500);
      }
    },
    
    matchManufacturer(manufacturerName) {
      if (!manufacturerName) return;
      this.form.manufacturerName = manufacturerName;
      if (this.manufacturerOptions && this.manufacturerOptions.length > 0) {
        const matched = this.manufacturerOptions.find(item => item.manufacturerName === manufacturerName);
        if (matched) {
          this.form.manufacturer = matched.id;
          this.pendingManufacturerName = '';
          return;
        }
      }
      if (this.manufacturerQuery !== manufacturerName) {
        this.manufacturerQuery = manufacturerName;
        this.loadManufacturers(false);
      }
    },
    
    handlePeriodControlChange(val) {
      if (val === 0) {
        this.form.expyDate = null;
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate('expyDate');
          }
        });
      }
    },

    getExpyDateRules() {
      if (this.form.periodControl === 1) {
        return [
          { required: true, message: '请输入有效期天数', trigger: 'blur' },
          { validator: this.validatePositiveInteger, trigger: 'blur' }
        ];
      }
      return [];
    },
    validatePositiveInteger(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      const num = Number(value);
      if (!Number.isInteger(num) || num <= 0) {
        callback(new Error('有效期天数必须为正整数'));
      } else {
        callback();
      }
    },

    async validateForm() {
      this.enableFormValidation();
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.$refs.form.validate((valid) => {
            let hasError = false;
            if (this.form.periodControl === 1) {
              const expyDate = this.form.expyDate;
              if (expyDate === '' || expyDate === null || expyDate === undefined) {
                this.$alert('当前已启用效期管理，有效期天数不能为空！', '系统提示', {
                  confirmButtonText: '确定',
                  type: 'warning'
                });
                hasError = true;
              }
            }
            if (!valid || hasError) {
              reject(new Error('表单验证失败'));
            } else {
              resolve();
            }
          });
        });
      });
    },
    
    handleInputexpyDate(field, value){
      const num = Number(value);
      if (!Number.isInteger(num) || num <= 0) {
        this.$alert('当前字段："有效期天数"的值不规范！', '系统提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        this.form.expyDate = '';
      }
    },
    
    setFieldConfig(fieldConfig) {
      if (fieldConfig && fieldConfig.length > 0) {
        if (this.fieldConfigProcessed) {
          this.processFieldConfigImmediately(fieldConfig);
        } else {
          this.pendingFieldConfig = fieldConfig;
        }
      } else {
        this.setupDefaultFields();
      }
    },
    processFieldConfigImmediately(fieldConfig) {
      try {
        this.processFieldData(fieldConfig);
        this.fieldConfigProcessed = true;
      } catch (error) {
        this.$message.error('字段配置处理失败');
        this.setupDefaultFields();
      }
    },
    processPendingFieldConfig() {
      if (this.pendingFieldConfig) {
        this.processFieldConfigImmediately(this.pendingFieldConfig);
        this.pendingFieldConfig = null;
      }
    },
    processFieldData(fieldData) {
      try {
        const visibleFields = fieldData.filter(field =>
          Number(field.isShow) === 1 || Number(field.isMustFill) === 1 || Number(field.isMustChoose) === 1
        );
        this.dynamicFields = visibleFields.map(field => ({
          fieldCode: field.fieldCode,
          fieldName: field.fieldName || this.getDefaultFieldName(field.fieldCode),
          inputBoxType: field.inputBoxType || 'input',
          fieldType: field.fieldType || 'string',
          isShow: true,
          isMustFill: parseInt(field.isMustFill) || 0,
          isMustChoose: parseInt(field.isMustChoose) || 0,
          placeholder: field.placeholder || '',
          options: field.options || this.getDefaultFieldOptions(field.fieldCode),
          rules: this.generateFieldRules(field),
          colSpan: field.colSpan || 6,
          fieldCodeOption: field.fieldCodeOption || field.fieldCode
        }));
        this.buildFieldOptionsMap();
        this.buildFieldRulesMap();
        this.buildFieldCodeOptionsMap();
        this.fieldConfigProcessed = true;
        this.$forceUpdate();
      } catch (error) {
        console.error('处理字段数据失败:', error);
        throw error;
      }
    },
    setupDefaultFields() {
      const defaultFields = [
        { fieldCode: 'code', fieldName: '编码', inputBoxType: 'input', isShow: 1, isMustFill: 1 },
        { fieldCode: 'drugName', fieldName: '药品名称', inputBoxType: 'input', isShow: 1, isMustFill: 1 },
        { fieldCode: 'pyCode', fieldName: '拼音简码', inputBoxType: 'input', isShow: 1, isMustFill: 0 },
        { fieldCode: 'alis', fieldName: '药品别名', inputBoxType: 'input', isShow: 1, isMustFill: 0 },
        { fieldCode: 'alisPyCode', fieldName: '别名简码', inputBoxType: 'input', isShow: 1, isMustFill: 0 },
        { fieldCode: 'state', fieldName: '有效状态', inputBoxType: 'selected', isShow: 1, isMustChoose: 1 },
        { fieldCode: 'drugSpec', fieldName: '药品规格', inputBoxType: 'input', isShow: 1, isMustFill: 0 },
        { fieldCode: 'pacSpec', fieldName: '包装规格', inputBoxType: 'input', isShow: 1, isMustFill: 1 },
        { fieldCode: 'pacUnt', fieldName: '包装单位', inputBoxType: 'selected', isShow: 1, isMustChoose: 1 },
        { fieldCode: 'pacCnt', fieldName: '包装数量', inputBoxType: 'input', isShow: 1, isMustFill: 1 },
        { fieldCode: 'minUnt', fieldName: '最小单位', inputBoxType: 'selected', isShow: 1, isMustChoose: 1 },
        { fieldCode: 'minDose', fieldName: '最小剂量', inputBoxType: 'input', isShow: 1, isMustFill: 1 },
        { fieldCode: 'costPric', fieldName: '成本单价', inputBoxType: 'input', isShow: 1, isMustFill: 1 },
        { fieldCode: 'salePric', fieldName: '零售单价', inputBoxType: 'input', isShow: 1, isMustFill: 1 },
        { fieldCode: 'saleUnt', fieldName: '零售单位', inputBoxType: 'selected', isShow: 1, isMustChoose: 1 },
        { fieldCode: 'medcWayId', fieldName: '给药方式', inputBoxType: 'selected', isShow: 1, isMustChoose: 0 },
        { fieldCode: 'usedFrquId', fieldName: '用药频率', inputBoxType: 'selected', isShow: 1, isMustChoose: 0 },
        { fieldCode: 'markUpId', fieldName: '加成方式', inputBoxType: 'selected', isShow: 1, isMustChoose: 1 },
        { fieldCode: 'markUpFixed', fieldName: '固定加成', inputBoxType: 'selected', isShow: 1, isMustChoose: 0 },
        { fieldCode: 'markUpRate', fieldName: '加成比例', inputBoxType: 'input', isShow: 1, isMustFill: 0 },
        { fieldCode: 'markUpPric', fieldName: '加成金额', inputBoxType: 'input', isShow: 1, isMustFill: 0 },
        { fieldCode: 'expensiveType', fieldName: '贵重类型', inputBoxType: 'selected', isShow: 1, isMustChoose: 0 },
        { fieldCode: 'roundUnt', fieldName: '取整方式', inputBoxType: 'selected', isShow: 1, isMustChoose: 1 },
        { fieldCode: 'mrsId', fieldName: '病案费别', inputBoxType: 'selected', isShow: 1, isMustChoose: 1 },
        { fieldCode: 'intxAnstType', fieldName: '毒麻类型', inputBoxType: 'selected', isShow: 1, isMustChoose: 0 },
        { fieldCode: 'lmtSpc', fieldName: '适用范围', inputBoxType: 'selected', isShow: 1, isMustChoose: 0 }
      ];
      this.processFieldData(defaultFields);
    },
    getDefaultFieldName(fieldCode) {
      const map = {
        'code': '编码',
        'drugName': '药品名称',
        'pyCode': '拼音简码',
        'alis': '药品别名',
        'alisPyCode': '别名简码',
        'state': '有效状态',
        'drugSpec': '药品规格',
        'pacSpec': '包装规格',
        'unitDose': '单位剂量',
        'dosUntOption': '剂量单位',
        'pacUnt': '包装单位',
        'pacCnt': '包装数量',
        'minUnt': '最小单位',
        'minDose': '最小剂量',
        'costPric': '成本单价',
        'salePric': '零售单价',
        'saleUnt': '零售单位',
        'medcWayId': '给药方式',
        'usedFrquId': '用药频率',
        'tcmB': '内服药',
        'markUpId': '加成方式',
        'markUpFixed': '固定加成',
        'markUpRate': '加成比例',
        'markUpPric': '加成金额',
        'expensiveType': '贵重类型',
        'roundUnt': '取整方式',
        'mrsId': '病案费别',
        'intxAnstType': '毒麻类型',
        'phamType': '药理类别',
        'lmtSpc': '适用范围',
      };
      return map[fieldCode] || fieldCode;
    },
    getDefaultFieldOptions(fieldCode) {
      const map = {
        'state': this.statusOptions,
        'saleUnt': this.saleWaysOptions,
        'markUpId': this.markUpOption,
        'markUpFixed': this.YNoptions,
        'isBar': this.YNoptions,
        'tcmB': this.YNoptions,
        'expensiveType': this.expensiveTypeOptions,
        'roundUnt': this.roundUntoptions,
        'mrsId': this.medicalRecordFeeOption,
        'intxAnstType': this.poisonousTypeOption,
        'medcWayId': this.usedFrquIdOptions,
        'usedFrquId': this.medcWayIdOptions,
        'lmtSpc': this.lmtSpc,
        'nurtureType': this.nurtureType,
        'antcLv': this.antcLvOption,
        'dosUnt': this.dosUntOptions,
        'minUnt': this.minUntOptions,
      };
      return map[fieldCode] || [];
    },
    generateFieldRules(field) {
      const rules = [];
      if (this.isMarkUpRelatedField(field.fieldCode)) {
        const markUpRules = this.getMarkUpFieldRules(field);
        if (markUpRules) {
          rules.push(...markUpRules);
        }
      }
      if (field.isMustFill === 1 && field.inputBoxType === 'input') {
        rules.push({
          required: true,
          message: `请输入${field.fieldName}`,
          trigger: 'blur'
        });
      }
      if (field.isMustChoose === 1 && field.inputBoxType === 'selected') {
        rules.push({
          required: true,
          message: `请选择${field.fieldName}`,
          trigger: 'change'
        });
      }
      return rules;
    },
    isMarkUpRelatedField(fieldCode) {
      return ['markUpPric', 'markUpRate', 'markUpFixed'].includes(fieldCode);
    },
    getMarkUpFieldRules(field) {
      switch (field.fieldCode) {
        case 'markUpPric': return this.getMarkUpPricRules();
        case 'markUpRate': return this.getMarkUpRateRules();
        case 'markUpFixed': return this.getMarkUpFixedRules();
        default: return null;
      }
    },
    getMarkUpPricRules() {
      const rules = [];
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      if (markUpId === 2 && this.validateOnOpen) {
        rules.push({
          required: true,
          message: '请输入加成金额',
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value && value !== 0) {
              callback(new Error('请输入加成金额'));
            } else if (isNaN(parseFloat(value))) {
              callback(new Error('加成金额必须是数字'));
            } else if (parseFloat(value) <= 0) {
              callback(new Error('加成金额必须大于0'));
            } else if (!Number.isInteger(Number(value))) {
              callback(new Error('加成金额必须是正整数'));
            } else {
              callback();
            }
          }
        });
      }
      return rules;
    },
    getMarkUpRateRules() {
      const rules = [];
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      if ((markUpId === 1 || markUpId === 3) && this.validateOnOpen) {
        rules.push({
          required: true,
          message: '请输入加成比例',
          trigger: 'blur'
        });
        if (markUpId === 3) {
          rules.push({
            validator: this.validateManualMarkUpRate,
            message: '手工加成比例必须是大于1小于2的数字，最多3位小数',
            trigger: 'blur'
          });
        } else {
          rules.push({
            validator: this.validatePositiveNumber,
            message: '加成比例必须是大于0的数字',
            trigger: 'blur'
          });
        }
      }
      return rules;
    },
    getMarkUpFixedRules() {
      const rules = [];
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      if (markUpId === 2 && this.validateOnOpen) {
        rules.push({
          required: true,
          message: '请选择是否固定加成',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请选择是否固定加成'));
            } else if (value !== 1) {
              callback(new Error('固定加成模式下必须选择"是"'));
            } else {
              callback();
            }
          }
        });
      }
      return rules;
    },
    validateManualMarkUpRate(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入手工加成比例'));
        return;
      }
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        callback(new Error('手工加成比例必须是数字'));
        return;
      }
      if (numValue <= 1) {
        callback(new Error('手工加成比例必须大于 1'));
        return;
      }
      const decimalPlaces = (value.toString().split('.')[1] || '').length;
      if (decimalPlaces > 3) {
        callback(new Error('手工加成比例最多支持 3 位小数'));
        return;
      }
      callback();
    },
    validatePositiveNumber(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入数值'));
        return;
      }
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue <= 0) {
        callback(new Error('必须是大于0的数字'));
      } else {
        callback();
      }
    },
    parseMarkUpId(value) {
      if (value === undefined || value === null || value === '') return 1;
      const num = parseInt(value);
      return isNaN(num) ? 1 : num;
    },
    buildFieldOptionsMap() {
      this.fieldOptionsMap.clear();
      this.dynamicFields.forEach(field => {
        if (field.options && field.options.length > 0) {
          this.fieldOptionsMap.set(field.fieldCode, field.options);
        }
      });
    },
    buildFieldRulesMap() {
      this.fieldRulesMap.clear();
      this.dynamicFields.forEach(field => {
        if (field.rules && field.rules.length > 0) {
          this.fieldRulesMap.set(field.fieldCode, field.rules);
        }
      });
    },
    buildFieldCodeOptionsMap() {
      this.fieldCodeOptionsMap.clear();
      this.dynamicFields.forEach(field => {
        if (field.inputBoxType === 'selected') {
          const optionsArray = this.getOptionsByFieldCodeOption(field.fieldCodeOption);
          if (optionsArray && optionsArray.length > 0) {
            this.fieldCodeOptionsMap.set(field.fieldCode, optionsArray);
          }
        }
      });
    },
    getOptionsByFieldCodeOption(fieldCodeOption) {
      const map = {
        'isBar': this.YNoptions,
        'manualPric': this.YNoptions,
        'isFixPrice': this.YNoptions,
        'minUnt': this.minUntOptions,
        'dosUnt': this.dosUntOptions,
        'pacUnt': this.allUnitOptions,
        'saleUnt': this.saleWaysOptions,
        'medcWay': this.medcWayIdOptions,
        'usedFrquId': this.usedFrquIdOptions,
        'markUpId': this.markUpOption,
        'markUpFixed': this.YNoptions,
        'expensiveType': this.expensiveTypeOptions,
        'roundUnt': this.roundUntoptions,
        'mrsId': this.medicalRecordFeeOption,
        'intxAnstType': this.poisonousTypeOption,
        'state': this.statusOptions,
        'lmtc': this.lmtSpc,
        'nurtureType': this.nurtureType,
        'antcLv': this.antcLvOption,
      };
      return map[fieldCodeOption] || [];
    },
    rebuildFieldMaps() {
      this.buildFieldOptionsMap();
      this.buildFieldRulesMap();
      this.buildFieldCodeOptionsMap();
    },
    forceReRenderFields() {
      this.fieldRenderKey++;
    },

    getFieldRequiredRules(fieldCode) {
      const field = this.dynamicFields.find(f => f.fieldCode === fieldCode);
      if (!field) return [];
      const rules = [];
      if (this.validateOnOpen) {
        if (field.isMustFill === 1 && field.inputBoxType === 'input') {
          rules.push({
            required: true,
            message: `请输入${field.fieldName}`,
            trigger: 'blur'
          });
        }
        if (field.isMustChoose === 1 && field.inputBoxType === 'selected') {
          rules.push({
            required: true,
            message: `请选择${field.fieldName}`,
            trigger: 'change'
          });
        }
      }
      return rules;
    },
    getFieldRules(field) {
      return this.fieldRulesMap.get(field.fieldCode) || [];
    },
    getFieldOptions(field) {
      if (this.fieldCodeOptionsMap.has(field.fieldCode)) {
        return this.fieldCodeOptionsMap.get(field.fieldCode);
      }
      return field.options || [];
    },
    getFieldPlaceholder(field) {
      return field.placeholder || `请输入${field.fieldName}`;
    },
    getFieldDisabled(field) {
      let disabled = this.formDisabled || this.mode === 'view';
      if (field.fieldCode === 'pacCnt') {
        disabled = disabled || this.disablePackingQuantity;
      }
      if (field.fieldCode === 'markUpFixed') {
        disabled = true;
      }
      if (field.fieldCode === 'markUpPric') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        disabled = disabled || markUpId !== 2;
      }
      if (field.fieldCode === 'markUpRate') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        disabled = disabled || markUpId === 2;
      }
      return disabled;
    },
    getNumberFieldClass(field) {
      const numberFields = [
        'unitDose', 'pacCnt', 'minDose', 'fixMinSalePric', 'fixPacSalePric',
        'costPric', 'salePric', 'markUpRate', 'markUpPric'
      ];
      if (numberFields.includes(field.fieldCode)) return 'number-input-field';
      return '';
    },
    getNumberMin(field) {
      if (field.fieldCode === 'pacCnt') return 1;
      return 0;
    },
    getNumberMax(field) {
      const maxMap = {
        'pacCnt': 999999,
        'unitDose': 999999,
        'minDose': 999999,
        'fixMinSalePric': 999999,
        'fixPacSalePric': 999999,
        'costPric': 999999,
        'salePric': 999999,
        'markUpRate': 1000,
        'markUpPric': 999999
      };
      return maxMap[field.fieldCode] || 999999;
    },
    getNumberStep(field) {
      if (field.fieldCode === 'pacCnt') return 1;
      return 0.01;
    },
    getNumberPrecision(field) {
      const precisionMap = {
        'unitDose': 4,
        'minDose': 4,
        'fixMinSalePric': 2,
        'fixPacSalePric': 2,
        'costPric': 4,
        'salePric': 4,
        'markUpRate': 4,
        'markUpPric': 2
      };
      return precisionMap[field.fieldCode] || 2;
    },
    getCascaderOptions(field) {
      if (field.fieldCode === 'phamType') return this.phamTypeOptions;
      return field.options || [];
    },
    getCascaderProps(field) {
      if (field.fieldCode === 'phamType') return this.cascaderProps;
      return { value: 'value', label: 'label', children: 'children' };
    },
    getDatePickerType(field) {
      return field.dateType || 'datetime';
    },
    handleFieldBlur(field) {
      if (!this.validateOnOpen) {
        this.updateForm();
        return;
      }
      switch (field.fieldCode) {
        case 'costPric': this.handleCostPriceBlur(); break;
        case 'markUpRate': this.handleMarkUpRateBlur(); break;
        case 'markUpPric': this.handleMarkUpPricBlur(); break;
        case 'pacCnt': this.handlePacCntBlur(); break;
        default: this.updateForm(); break;
      }
    },
    handleFieldInput(field, value) {
      const validatedValue = this.validateNumberInput(field, value);
      if (validatedValue !== value) {
        this.form[field.fieldCode] = validatedValue;
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
      if (field.fieldCode === 'alis') {
        this.handleAliasInput(this.form.alis);
      }
      if (field.fieldCode === 'costPric') {
        this.handleCostPriceChange(this.form.costPric);
      }
      if (field.fieldCode === 'markUpRate') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        if (markUpId === 1 || markUpId === 3) {
          this.handleMarkUpRateInput(field, value);
        }
      }
      if (field.fieldCode === 'markUpPric') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        if (markUpId === 2) {
          this.handleMarkUpPricInput(field, value);
        }
      }
      this.updateForm();
      if (this.validateOnOpen && this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.validateField(field.fieldCode);
        });
      }
    },
    handleFieldChange(field, value) {
      if (this.isNumberField(field.fieldCode)) {
        this.finalValidateNumberField(field, value);
      }
      if (field.fieldCode === 'markUpId') {
        this.handleMarkUpChange(this.form.markUpId);
      }
      if (field.fieldCode === 'pacUnt') {
        this.handlePacUntChange(this.form.pacUnt);
      }
      if (field.fieldCode === 'minUnt') {
        this.handleMinUntChange(this.form.minUnt);
      }
      this.updateForm();
      if (this.validateOnOpen && this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.validateField(field.fieldCode);
        });
      }
    },
    isNumberField(fieldCode) {
      return ['unitDose', 'pacCnt', 'minDose', 'fixMinSalePric', 'fixPacSalePric',
        'costPric', 'salePric', 'markUpRate', 'markUpPric'].includes(fieldCode);
    },
    finalValidateNumberField(field, value) {
      if (value === '' || value === null || value === undefined) return;
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        this.$message.warning(`${field.fieldName}必须是有效的数字`);
        this.form[field.fieldCode] = '';
        return;
      }
      if (field.fieldCode === 'pacCnt') {
        if (!Number.isInteger(numValue) || numValue <= 0) {
          this.$message.warning('包装数量必须是大于0的正整数');
          this.form.pacCnt = 1;
          return;
        }
      }
      if (numValue < 0) {
        this.$message.warning(`${field.fieldName}不能为负数`);
        this.form[field.fieldCode] = Math.abs(numValue).toString();
      }
    },
    validateNumberInput(field, value) {
      const numberFields = [
        'unitDose', 'pacCnt', 'minDose', 'fixMinSalePric', 'fixPacSalePric',
        'costPric', 'salePric', 'markUpRate', 'markUpPric'
      ];
      if (!numberFields.includes(field.fieldCode)) return value;
      if (value === '' || value === null || value === undefined) return value;
      let strValue = String(value);
      strValue = strValue.replace(/[^\d.-]/g, '');
      const parts = strValue.split('.');
      if (parts.length > 2) {
        strValue = parts[0] + '.' + parts.slice(1).join('');
      }
      if (strValue.includes('-')) {
        const dashCount = (strValue.match(/-/g) || []).length;
        if (dashCount > 1) {
          strValue = '-' + strValue.replace(/-/g, '');
        } else if (!strValue.startsWith('-')) {
          strValue = '-' + strValue.replace(/-/g, '');
        }
      }
      if (strValue.startsWith('.')) {
        strValue = '0' + strValue;
      }
      if (strValue.startsWith('-.') && strValue.length > 2) {
        strValue = '-0' + strValue.substring(2);
      }
      return strValue;
    },
    handleCostPriceBlur() {
      if (this.form.costPric && !isNaN(parseFloat(this.form.costPric))) {
        this.form.costPric = parseFloat(this.form.costPric).toFixed(4);
      }
      this.calculateSalePrice();
      this.updateForm();
    },
    handleMarkUpRateBlur() {
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      if (markUpId === 3) {
        this.handleManualMarkUpRateBlur();
      } else if (markUpId === 1) {
        this.handleProportionalMarkUpRateBlur();
      } else {
        this.handleCommonMarkUpRateBlur();
      }
    },
    handleManualMarkUpRateBlur() {
      if (this.form.markUpRate) {
        const value = this.form.markUpRate.toString().trim();
        if (value === '') {
          this.form.markUpRate = '';
          this.$message.warning('手工加成比例不能为空');
          return;
        }
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.form.markUpRate = '';
          this.$message.warning('手工加成比例必须是数字');
          return;
        }
        if (numValue <= 1) {
          this.form.markUpRate = '';
          this.$message.warning('手工加成比例必须大于 1');
          return;
        }
        const decimalPlaces = (value.toString().split('.')[1] || '').length;
        if (decimalPlaces > 3) {
          this.form.markUpRate = parseFloat(numValue.toFixed(3));
          this.$message.warning('手工加成比例最多支持 3 位小数，已自动截断');
        } else {
          this.form.markUpRate = value;
        }
      }
      this.calculateSalePrice();
      this.updateForm();
    },
    handleProportionalMarkUpRateBlur() {
      if (this.form.markUpRate) {
        const value = this.form.markUpRate.toString().trim();
        if (value === '') {
          this.form.markUpRate = '';
          this.$message.warning('加成比例不能为空');
          return;
        }
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.form.markUpRate = '';
          this.$message.warning('加成比例必须是数字');
          return;
        }
        if (numValue <= 0) {
          this.form.markUpRate = '';
          this.$message.warning('加成比例必须大于0');
          return;
        }
        const decimalPlaces = (value.toString().split('.')[1] || '').length;
        if (decimalPlaces > 3) {
          this.form.markUpRate = parseFloat(numValue.toFixed(3));
          this.$message.warning('加成比例最多支持3位小数，已自动截断');
        } else {
          this.form.markUpRate = value;
        }
      }
      this.calculateSalePrice();
      this.updateForm();
    },
    handleCommonMarkUpRateBlur() {
      if (this.form.markUpRate && !isNaN(parseFloat(this.form.markUpRate))) {
        const rate = parseFloat(this.form.markUpRate);
        if (rate > 0) {
          this.form.markUpRate = rate.toFixed(2);
        }
      }
      this.calculateSalePrice();
      this.updateForm();
    },
    handleMarkUpPricBlur() {
      if (this.form.markUpPric) {
        const value = this.form.markUpPric.toString().trim();
        if (value === '') {
          this.form.markUpPric = '0';
          this.$message.warning('加成金额不能为空，已设置为0');
          return;
        }
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.form.markUpPric = '0';
          this.$message.warning('加成金额必须是数字，已设置为0');
          return;
        }
        if (numValue < 0) {
          this.form.markUpPric = '0';
          this.$message.warning('加成金额不能为负数，已设置为0');
          return;
        }
        if (numValue === 0) {
          this.form.markUpPric = '0';
        } else {
          const decimalPlaces = (value.toString().split('.')[1] || '').length;
          if (decimalPlaces > 3) {
            this.form.markUpPric = parseFloat(numValue.toFixed(3));
            this.$message.warning('加成金额最多支持3位小数，已自动截断');
          } else {
            this.form.markUpPric = value;
          }
        }
      } else {
        this.form.markUpPric = '0';
      }
      this.calculateSalePrice();
      this.updateForm();
    },
    handlePacCntBlur() {
      if (this.form.pacUnt && this.form.minUnt && this.form.pacUnt === this.form.minUnt) {
        this.form.pacCnt = 1;
        this.$message.warning('包装单位和最小单位相同，包装数量必须为1');
      }
      this.updateForm();
    },
    handleCostPriceChange(value) {
      if (value !== '' && !isNaN(value) && parseFloat(value) >= 0) {
        this.form.costPric = value;
        if (this.form.markUpId === 1) {
          this.$nextTick(() => {
            this.calculateMarkUpRateFromApi();
          });
        }
        this.calculateSalePrice();
        if (this.form.markUpId === 4) {
          this.$nextTick(() => {
            this.calculateSalePriceForNoMarkUp();
          });
        }
      } else {
        this.form.costPric = '';
      }
    },
    calculateSalePrice() {
      if (!this.form.costPric) return;
      const cost = parseFloat(this.form.costPric);
      if (isNaN(cost) || cost <= 0) return;
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      switch (markUpId) {
        case 1:
          if (this.form.markUpRate) {
            const rate = parseFloat(this.form.markUpRate);
            if (!isNaN(rate) && rate > 0) {
              this.form.salePric = (cost * rate).toFixed(4);
            }
          }
          break;
        case 2:
          if (this.form.markUpPric) {
            const markup = parseFloat(this.form.markUpPric);
            if (!isNaN(markup) && markup >= 0) {
              this.form.salePric = (cost + markup).toFixed(4);
            }
          }
          break;
        case 3:
          this.calculateManualProportionalMarkUp(cost);
          break;
        case 4:
          this.calculateNoMarkUp(cost);
          break;
      }
      this.updateForm();
    },
    calculateManualProportionalMarkUp(cost) {
      if (!this.form.markUpRate) {
        this.form.salePric = '';
        return;
      }
      const rate = parseFloat(this.form.markUpRate);
      if (isNaN(rate) || rate <= 0) {
        this.form.salePric = '';
        return;
      }
      const salePrice = cost * rate;
      this.form.salePric = salePrice.toFixed(4);
    },
    calculateNoMarkUp(cost) {
      this.form.salePric = cost.toFixed(4);
      this.form.markUpPric = '0';
      this.form.markUpRate = '1';
      this.form.markUpFixed = 0;
    },
    calculateSalePriceForNoMarkUp() {
      if (!this.form.costPric) return;
      const cost = parseFloat(this.form.costPric);
      if (isNaN(cost)) return;
      this.form.salePric = cost.toFixed(4);
      this.updateForm();
    },
    handleAliasInput(value) {
      this.form.alisPyCode = this.getFirstLetter(value);
      this.updateForm();
    },
    handleMarkUpRateInput(field, value) {
      let validatedValue = value.replace(/[^\d.]/g, '');
      const parts = validatedValue.split('.');
      if (parts.length > 2) {
        validatedValue = parts[0] + '.' + parts.slice(1).join('');
      }
      this.form[field.fieldCode] = validatedValue;
      this.calculateSalePrice();
      this.updateForm();
    },
    handleMarkUpPricInput(field, value) {
      let validatedValue = value.replace(/[^\d.]/g, '');
      const parts = validatedValue.split('.');
      if (parts.length > 2) {
        validatedValue = parts[0] + '.' + parts.slice(1).join('');
      }
      if (validatedValue) {
        const numValue = parseFloat(validatedValue);
        if (!isNaN(numValue) && numValue < 0) {
          validatedValue = Math.abs(numValue).toString();
        }
      }
      this.form[field.fieldCode] = validatedValue;
      if (this.form.costPric && validatedValue) {
        this.calculateSalePrice();
      }
      this.updateForm();
    },
    calculateMarkUpRateFromApi() {
      if (this.form.markUpId === 1) {
        this.calculateSalePriceDirectly();
      }
    },
    calculateSalePriceDirectly() {
      if (!this.form.costPric || !this.form.markUpRate) return;
      const cost = parseFloat(this.form.costPric);
      const rate = parseFloat(this.form.markUpRate);
      if (isNaN(cost) || isNaN(rate) || cost <= 0 || rate <= 0) return;
      const salePrice = cost * rate;
      this.form.salePric = salePrice.toFixed(4);
      this.updateForm();
    },
    handleMarkUpChange(value) {
      const markUpId = this.parseMarkUpId(value);
      switch (markUpId) {
        case 1:
          this.form.markUpRate = '1';
          this.handleProportionalMarkUpWithReset();
          break;
        case 2:
          this.handleFixedMarkUpWithReset();
          break;
        case 3:
          this.handleManualProportionalMarkUpWithValidation();
          if (!this.form.markUpRate || this.form.markUpRate === '') {
            this.form.markUpRate = '1';
          }
          if (this.form.costPric) {
            this.calculateSalePriceForManualMarkUp();
          }
          break;
        case 4:
          this.handleNoMarkUpWithDefault();
          break;
      }
      this.forceUpdateValidationRules();
      this.updateForm();
    },
    handleProportionalMarkUpWithReset() {
      this.setMarkUpFieldState({
        markUpRate: false,
        markUpPric: true,
        markUpFixed: true
      });
      this.form.markUpPric = '0';
      this.form.markUpFixed = 0;
      this.$nextTick(() => {
        this.calculateSalePrice();
      });
    },
    handleFixedMarkUpWithReset() {
      this.setMarkUpFieldState({
        markUpRate: true,
        markUpPric: false,
        markUpFixed: true
      });
      this.form.markUpRate = '1';
      this.form.markUpFixed = 1;
      if (!this.form.markUpPric || this.form.markUpPric === '') {
        this.form.markUpPric = '0';
      }
      this.$nextTick(() => {
        this.calculateSalePrice();
      });
    },
    handleManualProportionalMarkUpWithValidation() {
      this.setMarkUpFieldState({
        markUpRate: false,
        markUpPric: true,
        markUpFixed: true
      });
      if (!this.form.markUpRate || this.form.markUpRate === '') {
        this.form.markUpRate = '1';
      }
      this.form.markUpPric = '';
      this.form.markUpFixed = 0;
      this.$nextTick(() => {
        this.validateMarkUpRateField();
        if (this.form.costPric && this.form.markUpRate) {
          this.calculateSalePriceForManualMarkUp();
        }
      });
    },
    handleNoMarkUpWithDefault() {
      this.setMarkUpFieldState({
        markUpRate: true,
        markUpPric: true,
        markUpFixed: true
      });
      this.form.markUpRate = '1';
      this.form.markUpPric = '0';
      this.form.markUpFixed = 0;
      this.$nextTick(() => {
        this.calculateSalePriceForNoMarkUp();
      });
    },
    setMarkUpFieldState(state) {},
    validateMarkUpRateField() {
      if (this.$refs.form && this.form.markUpId === 3) {
        this.$refs.form.validateField('markUpRate');
      }
    },
    calculateSalePriceForManualMarkUp() {
      if (!this.form.costPric || !this.form.markUpRate) return;
      const cost = parseFloat(this.form.costPric);
      const rate = parseFloat(this.form.markUpRate);
      if (isNaN(cost) || isNaN(rate) || rate <= 0) return;
      const salePrice = cost * rate;
      this.form.salePric = salePrice.toFixed(4);
      this.updateForm();
    },
    forceUpdateValidationRules() {
      this.buildFieldRulesMap();
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },

    handlePacUntChange(value) {
      if (this.unitChangeInProgress) return;
      this.unitChangeInProgress = true;
      this.$nextTick(() => {
        this.checkUnitSame();
        this.unitChangeInProgress = false;
        this.updateForm();
      });
    },
    handleMinUntChange(value) {
      if (this.unitChangeInProgress) return;
      this.unitChangeInProgress = true;
      this.$nextTick(() => {
        this.checkUnitSame();
        this.unitChangeInProgress = false;
        this.updateForm();
      });
    },
    checkUnitSame() {
      if (this.form.pacUnt && this.form.minUnt && this.form.pacUnt === this.form.minUnt) {
        this.form.pacCnt = 1;
        this.$message.info('包装单位和最小单位相同，包装数量已自动设置为1');
      }
    },

    ensureTopFieldsExist() {
      Object.keys(this.defaultTopFields).forEach(key => {
        if (!(key in this.form)) {
          this.$set(this.form, key, this.defaultTopFields[key]);
        }
      });
    },
    initForm() {
      if (!this.form.markUpId) {
        this.form.markUpId = 4;
      }
      this.updateMarkUpName();
    },
    updateMarkUpName() {
      this.form.markUpName = this.currentMarkUpName;
    },
    setMarkUpNameByMarkUpId(markUpId) {
      if (markUpId && this.markUpNameMap[markUpId]) {
        this.form.markUpName = this.markUpNameMap[markUpId];
      } else {
        this.form.markUpName = '';
      }
    },
    resetValidation() {
      this.validateOnOpen = false;
      this.validationInitialized = false;
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    enableFormValidation() {
      this.validateOnOpen = true;
    },

    async pacUnt() {
      let res = await getDrugUnt();
      if (res.code === 200) {
        this.allUnitOptions = res.data.map(v => ({ label: v.name, ...v }));
        this.filteredUnitOptions = [...this.allUnitOptions];
      } else {
        this.$message.error(res.message);
      }
    },
    async getDosaUnts() {
      let res = await getDosaUnt();
      if (res.code === 200) {
        this.dosUntOptions = res.data.map(v => ({ label: v.name, ...v }));
        this.minUntOptions = res.data.map(v => ({ label: v.name, ...v }));
      } else {
        this.$message.error(res.message);
      }
    },
    async getMedicationFrequency() {
      let res = await getMedicationFrequency();
      if (res.code === 200) {
        this.usedFrquIdOptions = res.data.map(v => ({ label: v.name, ...v }));
      } else {
        this.$message.error(res.message);
      }
    },
    async getMedicationWay() {
      let res = await getMedicationWay();
      if (res.code === 200) {
        this.medcWayIdOptions = res.data.map(v => ({ label: v.name, ...v }));
      } else {
        this.$message.error(res.message);
      }
    },
    async getMedcas() {
      try {
        const res = await getMedcas();
        if (res.code === 200) {
          this.medicalRecordFeeOption = res.data.map(v => ({ label: v.name, id: v.id, ...v }));
          if (this.form.drugType === 1) {
            this.setMedicalRecordFeeForWesternMedicine();
          }
          if (this.form.antc === 1) {
            this.setMedicalRecordFeeForAntibiotic();
          }
        }
      } catch (error) {
        console.error('获取病案费别失败:', error);
      }
    },
    setMedicalRecordFeeForWesternMedicine() {
      if (this.form.drugType === 1 && this.form.antc !== 1) {
        const westernMedicineOption = this.medicalRecordFeeOption.find(option =>
          option.label && option.label.includes('西药费')
        );
        if (westernMedicineOption) {
          this.form.mrsId = westernMedicineOption.id;
          this.updateForm();
        }
      }
    },
    setMedicalRecordFeeForAntibiotic() {
      if (this.form.antc === 1) {
        const antibioticOption = this.medicalRecordFeeOption.find(option =>
          option.label && option.label.includes('抗生素费')
        );
        if (antibioticOption) {
          this.form.mrsId = antibioticOption.id;
          this.updateForm();
        }
      }
    },
    async loadUnitOptions() {
      try {
        const pacUntRes = await getDrugUnt();
        if (pacUntRes.code === 200) {
          this.allUnitOptions = pacUntRes.data.map(v => ({ label: v.name, ...v }));
          this.filteredUnitOptions = [...this.allUnitOptions];
          this.minUntOptions = [...this.allUnitOptions];
        }
        const dosUntRes = await getDosaUnt();
        if (dosUntRes.code === 200) {
          this.dosUntOptions = dosUntRes.data.map(v => ({ label: v.name, ...v }));
        }
      } catch (error) {
        console.error('加载单位选项失败:', error);
      }
    },
    async loadDosageFormOptions() {
      try {
        const response = await getDosageForm({
          pageNum: 1,
          pageSize: 1000
        });
        if (response.code === 200) {
          const data = response.data.content || response.data.list || response.data || [];
          this.dosageFormOptions = data.map(item => ({
            id: item.id || item.dosageFormId || item.value,
            label: item.name || item.dosageFormName || item.label || item.text,
            dosageName: item.dosageName || item.name,
            code: item.code,
            ...item
          }));
        }
      } catch (error) {
        console.error('获取药品剂型失败:', error);
      }
    },

    async loadManufacturers(isLoadMore = false) {
      try {
        if (!isLoadMore) {
          this.manufacturerLoading = true;
          this.manufacturerPageNum = 1;
        } else {
          this.manufacturerScrollLoading = true;
        }
        const params = {
          manufacturerName: this.manufacturerQuery,
          status: 1,
          pageNum: this.manufacturerPageNum,
          pageSize: this.manufacturerPageSize
        };
        const res = await getManufacturer(params);
        if (res.code === 200) {
          const content = res.data.content || [];
          const newData = content.map(item => ({
            id: item.id,
            manufacturerName: item.manufacturerName,
            coding: item.coding || '',
            origin: item.origin || item.orplc || ''
          }));
          if (isLoadMore) {
            this.manufacturerOptions = [...this.manufacturerOptions, ...newData];
          } else {
            this.manufacturerOptions = newData;
          }
          this.manufacturerHasMore = content.length >= this.manufacturerPageSize;
    
          if (this.pendingManufacturerName) {
            const matched = this.manufacturerOptions.find(item => item.manufacturerName === this.pendingManufacturerName);
            if (matched) {
              this.form.manufacturer = matched.id;
              this.pendingManufacturerName = '';
            } else {
              this.form.manufacturer = null;
            }
          }
        } else {
          this.$message.error(res.message || '获取生产厂家失败');
        }
      } catch (error) {
        console.error('加载生产厂家失败:', error);
        this.$message.error('加载生产厂家失败');
      } finally {
        this.manufacturerLoading = false;
        this.manufacturerScrollLoading = false;
      }
    },
    handleManufacturerSearch: _.debounce(function(query) {
      this.manufacturerQuery = query.trim();
      this.manufacturerPageNum = 1;
      this.loadManufacturers(false);
    }, 500),
    handleManufacturerScroll() {
      if (this.manufacturerHasMore && !this.manufacturerScrollLoading && !this.manufacturerLoading) {
        this.manufacturerPageNum++;
        this.loadManufacturers(true);
      }
    },
    handleManufacturerChange(val) {
      if (!val) {
        this.form.manufacturerName = null;
        return;
      }
      const selected = this.manufacturerOptions.find(item => item.id === val);
      if (selected) {
        this.form.manufacturerName = selected.manufacturerName;
      } else {
        this.form.manufacturerName = null;
      }
    },
    openAddManufacturerDialog() {
      this.quickAddManufacturerDialogVisible = true;
      if (this.manufacturerQuery) {
        this.quickAddManufacturerForm.manufacturerName = this.manufacturerQuery;
        this.quickAddManufacturerForm.pinyinCode = this.getFirstLetter(this.manufacturerQuery);
      }
    },
    async handleAddManufacturerSubmit() {
      try {
        const valid = await this.$refs.quickAddManufacturerForm.validate();
        if (!valid) return;
        this.quickAddManufacturerLoading = true;
        const res = await addManufacturer(this.quickAddManufacturerForm);
        if (res.code === 200) {
          this.$message.success('生产厂家添加成功！');
          this.quickAddManufacturerDialogVisible = false;
          this.quickAddManufacturerForm = this.getDefaultQuickAddForm();
          this.manufacturerQuery = '';
          this.loadManufacturers(false);
          if (res.data && res.data.id) {
            this.form.manufacturer = res.data.id;
          }
        } else {
          this.$message.error(res.message || '添加失败');
        }
      } catch (error) {
        console.error('添加生产厂家失败:', error);
        this.$message.error('添加生产厂家失败');
      } finally {
        this.quickAddManufacturerLoading = false;
      }
    },
    getDefaultQuickAddForm() {
      return {
        applicableObject: "",
        businessLicense: "",
        coding: "",
        contactNumber: "",
        contacts: "",
        creditCode: "",
        email: "",
        fax: "",
        hygieneValidityPeriod: "",
        hygienicLicense: "",
        id: 0,
        manufacturerName: "",
        origin: "",
        periodValidity: this.getCurrentDate(),
        pinyinCode: "",
        postalCode: "",
        productionLicense: "",
        productionValidityPeriod: this.getCurrentDate(),
        region: "",
        remake: "",
        status: 1,
        url: ""
      };
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async fetchMedicalInsuranceData() {
      if (!this.form.manuLotnum || this.form.manuLotnum.trim() === '') {
        this.$alert('请先填写批准文号再尝试获取医保数据！', '系统提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        return;
      }
      try {
        const res = await getPariCode({ approvalNumber: this.form.manuLotnum.trim() });
        if (res.code === 200 && res.data) {
          const { mcCode, registeredName } = res.data;
          this.form.chsCode = mcCode || '';
          this.form.chsName = registeredName || '';
          this.$message.success('医保数据获取成功');
        } else {
          this.$message.error(res.message || '获取医保数据失败');
        }
      } catch (error) {
        console.error('获取医保数据失败:', error);
        this.$message.error('获取医保数据失败，请稍后重试');
      }
    },

    getFirstLetter(str) {
      if (!str || typeof str !== 'string') return '';
      try {
        const chineseChars = str.match(/[\u4e00-\u9fa5]/g) || [];
        if (chineseChars.length === 0) return '';
        const initials = chineseChars.map(char => {
          const pinyinResult = pinyin(char, { toneType: 'none', type: 'array', multiple: false })[0] || '';
          return pinyinResult.charAt(0).toUpperCase();
        });
        return initials.join('');
      } catch (error) {
        console.error('拼音转换失败:', error);
        return '';
      }
    },
    handleNumberInput(field, value) {
      if (value !== '' && value !== null && value !== undefined) {
        const num = Number(value);
        if (!isNaN(num) && num >= 0) {
          this.form[field] = Math.floor(num);
        } else {
          this.form[field] = null;
        }
      } else {
        this.form[field] = null;
      }
    },
    showRequiredField(fieldCode) {
      const field = this.dynamicFields.find(f => f.fieldCode === fieldCode);
      if (!field) return false;
      return field.isMustFill === 1 || field.isMustChoose === 1;
    },
    setPacCntDisabledState(kcId) {
      const shouldDisable = kcId === 1;
      if (this.disablePackingQuantity !== shouldDisable) {
        this.disablePackingQuantity = shouldDisable;
      }
    },
    handleMarkUpIdChange(markUpId) {
      this.handleMarkUpChange(markUpId);
    },
    initPhamTypeValue() {},
    loadPhamTypeChildren(node, resolve) {
      resolve([]);
    },
    updateForm() {
      this.$emit('update', this.form);
    },
  }
};
</script>

<style lang="less" scoped>
.basic-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .basic-info-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    
    .el-form {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      
      .el-form-item {
        .el-form-item__label {
          text-align: left;
          justify-content: flex-start;
        }
        .el-form-item__content {
          .el-input__inner,
          .el-textarea__inner,
          .el-select .el-input__inner {
            text-align: left;
          }
        }
      }
      
      .form-scroll-container {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        padding: 12px;
        box-sizing: border-box;
        
        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        &::-webkit-scrollbar-track {
          background: #f5f5f5;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
          &:hover {
            background: #a8a8a8;
          }
        }
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f5f5f5;
        
        .required-fields-row {
          .el-col {
            margin-bottom: 8px;
            .form-item-adaptive {
              margin-bottom: 0;
              display: flex;
              align-items: stretch;
              height: 100%;
              
              ::v-deep .el-form-item__label {
                background-color: #f5f7fa;
                border: 1px solid #dcdfe6;
                border-right: none;
                padding: 0 8px;
                line-height: 36px;
                height: 36px;
                font-weight: bold;
                color: #00557f;
                width: auto;
                min-width: 100px;
                max-width: 150px;
                text-align: left;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 12px;
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                white-space: normal;
                word-break: break-word;
                flex-shrink: 0;
              }
              
              ::v-deep .el-form-item__content {
                border: 1px solid #dcdfe6;
                border-left: none;
                line-height: 32px;
                height: 36px;
                flex: 1;
                margin-left: 0 !important;
                display: flex;
                align-items: center;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                
                .compact-input,
                .compact-select,
                .compact-input-number {
                  width: 100%;
                  height: 100%;
                  .el-input__inner {
                    border: none;
                    height: 100%;
                    line-height: 30px;
                    padding: 0 8px;
                    font-size: 12px;
                    color: #606266;
                    text-align: left;
                  }
                  .el-input-number__decrease,
                  .el-input-number__increase {
                    display: none;
                  }
                }
                .switch-wrapper {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  height: 100%;
                  padding: 0 8px;
                  .el-switch {
                    vertical-align: middle;
                  }
                }
              }
            }
          }
        }
        
        .optional-fields-section {
          border-top: 1px solid #e8e8e8;
          padding-top: 8px;
          margin-top: 8px;
          .dynamic-fields-grid {
            .field-col {
              .form-item-adaptive {
                margin-bottom: 8px;
                display: flex;
                align-items: stretch;
                height: 100%;
                
                ::v-deep .el-form-item__label {
                  background-color: #f5f7fa;
                  border: 1px solid #dcdfe6;
                  border-right: none;
                  padding: 0 8px;
                  line-height: 32px;
                  height: 36px;
                  font-weight: bold;
                  color: #00557f;
                  width: auto;
                  min-width: 100px;
                  max-width: 150px;
                  text-align: left;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  font-size: 12px;
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                  white-space: normal;
                  word-break: break-word;
                  flex-shrink: 0;
                }
                
                ::v-deep .el-form-item__content {
                  border: 1px solid #dcdfe6;
                  border-left: none;
                  line-height: 32px;
                  height: 36px;
                  flex: 1;
                  margin-left: 0 !important;
                  display: flex;
                  align-items: center;
                  border-top-right-radius: 4px;
                  border-bottom-right-radius: 4px;
                  
                  .compact-input,
                  .compact-select,
                  .compact-cascader,
                  .compact-datepicker,
                  .compact-input-number {
                    width: 100%;
                    height: 100%;
                    .el-input__inner {
                      border: none;
                      height: 100%;
                      line-height: 30px;
                      padding: 0 8px;
                      font-size: 12px;
                      color: #606266;
                      text-align: left;
                    }
                    .el-input-number__decrease,
                    .el-input-number__increase {
                      display: none;
                    }
                  }
                  .compact-checkbox {
                    font-size: 12px;
                    color: #606266;
                    text-align: left;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// =============================================================
// 快速添加生产厂家模态框样式
// =============================================================
.quick-add-manufacturer-dialog {
  /deep/ .el-dialog__header {
    background: linear-gradient(135deg, #00557f 0%, #ebfaff 100%) !important;
    padding: 12px 20px !important;
    border-bottom: 1px solid #1f3a57;
    border-radius: 8px 8px 0 0;
    .el-dialog__title {
      color: #ffffff !important;
      font-size: 16px;
      font-weight: 600;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #ffffff !important;
      &:hover {
        color: #e6e6e6 !important;
      }
    }
  }
  
  // 模态框内的表单样式与主表单完全一致
  .manufacturer-form {
    .required-fields-row {
      .el-col {
        margin-bottom: 8px;
        .form-item-adaptive {
          margin-bottom: 0;
          display: flex;
          align-items: stretch;
          height: 100%;
          
          ::v-deep .el-form-item__label {
            background-color: #f5f7fa;
            border: 1px solid #dcdfe6;
            border-right: none;
            padding: 0 8px;
            line-height: 36px;
            height: 36px;
            font-weight: bold;
            color: #00557f;
            width: auto;
            min-width: 100px;
            max-width: 150px;
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 12px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            white-space: normal;
            word-break: break-word;
            flex-shrink: 0;
          }
          
          ::v-deep .el-form-item__content {
            border: 1px solid #dcdfe6;
            border-left: none;
            line-height: 32px;
            height: 36px;
            flex: 1;
            margin-left: 0 !important;
            display: flex;
            align-items: center;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            
            .compact-input,
            .compact-select,
            .compact-datepicker {
              width: 100%;
              height: 100%;
              .el-input__inner {
                border: none;
                height: 100%;
                line-height: 30px;
                padding: 0 8px;
                font-size: 12px;
                color: #606266;
                text-align: left;
              }
              .el-input__suffix {
                display: flex;
                align-items: center;
                right: 5px;
              }
            }
            .compact-textarea {
              .el-textarea__inner {
                border: none;
                min-height: 60px;
                font-size: 12px;
                color: #606266;
                resize: vertical;
              }
            }
          }
        }
      }
    }
  }
  
  // 必填字段红色星号
  .required-field-item ::v-deep .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
  
  // 对话框底部按钮
  .dialog-footer {
    padding: 12px;
    border-top: 1px solid #ebeef5;
    text-align: right;
    .el-button {
      font-size: 12px;
    }
  }
}

::v-deep .required-field-item .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.custom-unit-dropdown.el-select-dropdown {
  min-width: 168px !important;
  max-width: 268px !important;
}
.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__list {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 6px !important;
  margin: 0;
  justify-content: space-between;
}
.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item {
  flex: 0 0 calc(25% - 8px) !important;
  box-sizing: border-box;
  padding: 8px 4px;
  margin: 4px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  height: auto;
  min-height: 36px;
  line-height: 1.4;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item:hover {
  background-color: #f5f7fa !important;
  border-color: #00557f !important;
  color: #00557f !important;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 85, 127, 0.1) !important;
}
.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item.selected {
  background-color: #00557f !important;
  border-color: #00557f !important;
  color: #fff !important;
  font-weight: bold;
}

.manufacturer-select-dropdown .select-header {
  display: flex;
  padding: 6px 8px;
  background-color: #f1f1f1;
  font-size: 12px;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #dcdfe6;
}
.manufacturer-select-dropdown .select-header .header-item {
  text-align: left;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.manufacturer-select-dropdown .el-select-dropdown__item {
  padding: 0;
  height: auto;
  line-height: 2;
}
.manufacturer-select-dropdown .option-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 8px;
  font-size: 12px;
}
.manufacturer-select-dropdown .option-row .option-item {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-right: 1px solid #eee;
  padding: 0 6px;
}
.manufacturer-select-dropdown .option-row .option-item:last-child {
  border-right: none;
}
.manufacturer-select-dropdown .load-more,
.manufacturer-select-dropdown .no-data-prompt {
  text-align: center;
  padding: 12px;
  color: #909399;
  font-size: 12px;
}
.manufacturer-select-dropdown .no-data-prompt .quick-add-link {
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
}
</style>